import translationsStore from '../../stores/translationsStore';
import CommonValidator from './commonValidators';

class UserSharedFormsValidator {

    validateGenericRequiredField(field) {
        return CommonValidator.validateGenericRequiredField(field);
    }

    validateInteger(number) {
        return CommonValidator.validateInteger(number);
    }

    validateFirstName(firstName) {
        return CommonValidator.validateGenericRequiredFieldWithRestrictedChars('firstName', firstName);
    }

    validateLastName(lastName) {
        return CommonValidator.validateGenericRequiredFieldWithRestrictedChars('lastName', lastName);
    }

    validateUserName(userName) {
        return CommonValidator.validateUsernameField('userName', userName);
    }

    validateLDAPUserName(userName) {
        return CommonValidator.validateGenericRequiredField('userName', userName);
    }

    validateTenant(tenant) {
        return CommonValidator.validateGenericRequiredFieldWithConcreteName('tenant', tenant);
    }

    validateEmail(email) {
        return CommonValidator.validateEmail(email);
    }

    validateRequiredPassword(password) {
        return CommonValidator.validateRequiredPassword(password);
    }

    validatePassword(password) {
        const data = {
            password: password
        };

        return CommonValidator.validatePassword(data);
    }

    validateMatchPassword(password, confirmedPassword) {

        const data = {
            password: password,
            password_confirmation: confirmedPassword
        };

        const rules = {
            password: `required|confirmed`,
            password_confirmation: `required`
        };

        const errorMessages = {
            required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE'),
            confirmed: translationsStore.translate('PASSWORD_NOT_MATCH_ERROR_MESSAGE')
        };

        return CommonValidator.validate(data, rules, errorMessages);
    }

}

export default new UserSharedFormsValidator();
